import React from "react";

import classNames from "classnames";
import { lighten } from "polished";
import { Button as BSButton } from "react-bootstrap";
import styled from "styled-components";

const StyledButton = styled(BSButton)`
  background-color: ${({ $buttonColour, theme, inversed }) =>
    $buttonColour || (inversed ? "#fff" : theme.primaryColor)};
  min-height: ${({ height }) => height || "3.5rem"};
  max-height: ${({ $maxHeight }) => $maxHeight || ""};
  border: ${({ $buttonColour, theme }) =>
    `1px solid ${$buttonColour || theme.primaryColor}`};
  color: ${({ $buttonTextColour }) => $buttonTextColour || "#FFFFFF"};
  border-radius: ${({ theme }) => theme?.buttonBorderRadius || "0px"};

  &:disabled {
    background-color: ${({ $buttonColour, theme }) =>
      lighten(0.3, $buttonColour || theme.primaryColor)};
    border: ${({ $buttonColour, theme }) =>
      `1px solid ${lighten(0.3, $buttonColour || theme.primaryColor)}`};
  }

  &:hover,
  &:active,
  &:focus {
    background-color: ${({ $buttonHoverColour, theme }) =>
      lighten(0.1, $buttonHoverColour || theme.primaryColor)};
    border-color: ${({ $buttonHoverColour, theme }) =>
      lighten(0.1, $buttonHoverColour || theme.primaryColor)};
    box-shadow: ${({ $buttonHoverColour, theme }) =>
      `0 0 0 0.25rem ${lighten(
        0.5,
        $buttonHoverColour || theme.primaryColor
      )}`};
    color: ${({ $buttonHoverTextColour }) =>
      $buttonHoverTextColour || "#FFFFFF"};
  }
`;

function Button(props) {
  const {
    children,
    onClick,
    disabled,
    className,
    type,
    maxHeight,
    buttonColour,
    buttonTextColour,
    buttonHoverColour,
    buttonTextHoverColour,
    ...rest
  } = props;

  const buttonClassName = classNames("text-uppercase fw-bold", className);

  return (
    <StyledButton
      $maxHeight={maxHeight}
      className={buttonClassName}
      disabled={disabled}
      onClick={onClick}
      type={type ?? "button"}
      $buttonColour={buttonColour}
      $buttonTextColour={buttonTextColour}
      $buttonHoverColour={buttonHoverColour}
      $buttonHoverTextColour={buttonTextHoverColour}
      {...rest}
    >
      {children}
    </StyledButton>
  );
}

export default Button;
